import { WebeyezGoalKeyObj } from "@/types/services/webeyez";
import { WebeyezObject } from "@/types/localtypes";
import { webeyezService } from "@/services/webeyez/webeyez";

export const awsPrivateLinkGoalKeyImpl: WebeyezGoalKeyObj = {
  send(webeyezObject: WebeyezObject): void {
    webeyezService.publishEvent(webeyezObject);
  },
};
